import React from 'react'
interface Props {
  styleCssImage: string
}

const LogoWallet: React.FC<Props> = ({ styleCssImage }) => {
  return (
    <svg
     className={`${styleCssImage}`}
       width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="59.9996" height="60" rx="10" fill="#B28858" />
      <g >
        <path
          d="M37.6314 20.1153C40.3624 20.2383 42.0494 20.6213 43.2426 21.8145C45 23.5719 45 26.4003 45 32.0572C45 37.714 45 40.5425 43.2426 42.2998C41.4854 44.0572 38.6568 44.0572 33 44.0572H27C21.3431 44.0572 18.5147 44.0572 16.7574 42.2998C15 40.5425 15 37.714 15 32.0572C15 26.4003 15 23.5719 16.7574 21.8145C18.14 20.4319 20.1856 20.1371 23.75 20.0742"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 29.0566H21.2958C22.3677 29.0566 22.9036 29.0566 23.3843 29.2246C23.6778 29.3272 23.9536 29.4748 24.2018 29.6622C24.6082 29.9689 24.9054 30.4147 25.5 31.3066C26.0946 32.1985 26.3918 32.6443 26.7982 32.9511C27.0464 33.1384 27.3222 33.286 27.6158 33.3886C28.0964 33.5566 28.6323 33.5566 29.7042 33.5566H30.2958C31.3677 33.5566 31.9037 33.5566 32.3843 33.3886C32.6778 33.286 32.9537 33.1384 33.2018 32.9511C33.6081 32.6443 33.9054 32.1985 34.5 31.3066C35.0946 30.4147 35.3919 29.9689 35.7983 29.6622C36.0464 29.4748 36.3222 29.3272 36.6158 29.2246C37.0964 29.0566 37.6323 29.0566 38.7042 29.0566H45"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33 33.0529C32.5777 32.8523 32.1865 32.597 31.8355 32.2962C30.7119 31.3333 30 29.9038 30 28.3081C30 25.4086 32.3505 23.0581 35.25 23.0581C38.1495 23.0581 40.5 25.4086 40.5 28.3081C40.5 28.5627 40.4819 28.8132 40.4468 29.0581"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M29.8502 27.3216C29.0109 26.391 28.5 25.1585 28.5 23.8066C28.5 20.9071 30.8505 18.5566 33.75 18.5566C36.6495 18.5566 39 20.9071 39 23.8066C39 24.0613 38.9819 24.3117 38.9468 24.5566"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M28.6977 26.0279C27.6106 25.9143 26.6221 25.4688 25.8355 24.7947C24.7119 23.8318 24 22.4024 24 20.8066C24 17.9071 26.3505 15.5566 29.25 15.5566C31.2541 15.5566 32.996 16.6796 33.8806 18.3306"
          stroke="white"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_15021_176699">
          <rect width="36" height="36" fill="white" transform="translate(12 12)" />
        </clipPath>
      </defs>
    </svg>
  )
}



export default LogoWallet
